(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Image-with-text-split-slidershow-tank"] && !Shopify.designMode) return;
  try {
    
(() => {
  const inited = new WeakSet();

  const prefersReducedMotion = () =>
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function rafThrottle(fn) {
    let raf = 0;
    return (...args) => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        fn(...args);
      });
    };
  }

  function makeCloneSafe(el) {
    el.setAttribute("aria-hidden", "true");

    // 避免 ID 冲突
    el.querySelectorAll("[id]").forEach((n) => n.removeAttribute("id"));

    // 禁止交互
    el
      .querySelectorAll("a,button,input,select,textarea,[tabindex]")
      .forEach((n) => n.setAttribute("tabindex", "-1"));

    // clone 里不要 lazy，避免动画阶段空白
    el
      .querySelectorAll('img[loading="lazy"]')
      .forEach((img) => img.setAttribute("loading", "eager"));

    // split-words/animate-element：clone 里强制显示，避免重复动画/闪烁
    el.querySelectorAll("split-words").forEach((sw) => {
      sw.classList.remove("js-invisible");
      sw.removeAttribute("reveal-on-scroll");
      sw.style.opacity = "1";
      sw.style.clipPath = "none";
      sw.style.webkitClipPath = "none";
    });

    el.querySelectorAll("animate-element").forEach((ae) => {
      ae.style.opacity = "1";
      ae.style.transform = "none";
    });

    // 清掉过渡/动画，避免 clone 内部自己跑
    el.querySelectorAll("*").forEach((n) => {
      n.style.transition = "none";
      n.style.animation = "none";
    });
  }

  function init(root) {
    if (!root || inited.has(root)) return;

    const viewport = root.querySelector(".vertical-embla__viewport");
    var prevBtn = "";
    var nextBtn = "";
    const dots = root.querySelectorAll(".vertical-embla__dot");
    
    if (!viewport || typeof EmblaCarousel === "undefined") return;

    // 检测是否为移动端
    const isMobile = window.matchMedia("(max-width: 999px)").matches;

    if(isMobile){
      prevBtn = root.querySelector(".embla-btn--prev-mobile");
      nextBtn = root.querySelector(".embla-btn--next-mobile");
    }else{
      prevBtn = root.querySelector(".embla-btn--prev-pc");
      nextBtn = root.querySelector(".embla-btn--next-pc");
    }
    
    const embla = EmblaCarousel(viewport, {
      axis: isMobile ? "x" : "y",
      align: "start",
      loop:  true,
      dragFree: false,
      skipSnaps: false,
      containScroll: "trimSnaps",
      watchDrag: true,
      autoplay:false,
      // autoplay: { delay: 8000, stopOnInteraction: true, stopOnMouseEnter: true, playOnMouseLeave: true }
    });

    let slides = embla.slideNodes();

    let stage = null;
    let animating = false;
    let active = null;
    
    // 获取所有slide和最后一个slide
    const allSlides = Array.from(root.querySelectorAll('.vertical-embla__slide'));
    const lastSlide = allSlides[allSlides.length - 1];
    const lastSlideIndex = allSlides.length - 1;

    // -----------------------------
    // 方案B：移动端自适应高度
    // -----------------------------
    const mqMobile = window.matchMedia("(max-width: 999px)");

    let ro = null; // ResizeObserver for current slide card
    const setViewportHeightToSelected = () => {
      // 仅移动端启用“跟随高度”
      if (!mqMobile.matches) {
        viewport.style.height = ""; // 桌面交还给 CSS（--ve-height）
        return;
      }

      const idx = embla.selectedScrollSnap();
      const slide = slides[idx];
      if (!slide) return;

      // 尽量取 card 的真实内容高度
      const card = slide.querySelector(".vertical-embla__card") || slide;

      const h = Math.ceil(
        card.scrollHeight || card.getBoundingClientRect().height || 0
      );
      if (h > 0) viewport.style.height = `${h}px`;
    };

    const setViewportHeightToSelectedRaf = rafThrottle(setViewportHeightToSelected);

    const observeSelectedCard = () => {
      if (!mqMobile.matches) {
        ro && ro.disconnect();
        ro = null;
        return;
      }
      const idx = embla.selectedScrollSnap();
      const slide = slides[idx];
      if (!slide) return;

      const card = slide.querySelector(".vertical-embla__card") || slide;

      // 重新绑定 ResizeObserver
      ro && ro.disconnect();
      if ("ResizeObserver" in window) {
        ro = new ResizeObserver(() => setViewportHeightToSelectedRaf());
        ro.observe(card);
      }

      // 图片加载会影响高度：强制监听一次
      card.querySelectorAll("img").forEach((img) => {
        if (img.complete) return;
        img.addEventListener(
          "load",
          () => setViewportHeightToSelectedRaf(),
          { once: true }
        );
        img.addEventListener(
          "error",
          () => setViewportHeightToSelectedRaf(),
          { once: true }
        );
      });
    };

    const onViewportEnvChange = () => {
      setViewportHeightToSelected();
      observeSelectedCard();
      // reInit 让 Embla 重新计算 snap（高度变更时更稳）
      try {
        embla.reInit();
      } catch (_) {}
    };

    // 初始化时先同步一次
    setViewportHeightToSelected();
    observeSelectedCard();

    // 窗口变化（横竖屏、地址栏收起等）也同步
    window.addEventListener("resize", setViewportHeightToSelectedRaf);
    if (mqMobile.addEventListener) {
      mqMobile.addEventListener("change", onViewportEnvChange);
    } else if (mqMobile.addListener) {
      mqMobile.addListener(onViewportEnvChange);
    }

    // -----------------------------
    // stage / clone 过渡逻辑
    // -----------------------------
    const ensureStage = () => {
      if (stage) return stage;
      stage = document.createElement("div");
      stage.className = "vertical-embla__stage";
      // viewport.appendChild(stage);
      root.appendChild(stage);
      return stage;
    };

    const showStage = () => {
      ensureStage();
      root.classList.add("is-animating");
    };

    const hideStage = () => {
      if (stage) stage.innerHTML = "";
      root.classList.remove("is-animating");
    };

    const syncButtons = () => {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = !embla.canScrollPrev();
      nextBtn.disabled = !embla.canScrollNext();
    };
    
    // 同步指示器状态
    const syncDots = () => {
      const currentIndex = embla.selectedScrollSnap();
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add("is-active");
        } else {
          dot.classList.remove("is-active");
        }
      });
    };

    const revealRealSlide = (index) => {
      const real = slides[index];
      if (!real) return;
      real.querySelectorAll("split-words").forEach((sw) => {
        if (typeof sw.reveal === "function") {
          try {
            sw.reveal();
          } catch (_) {}
        } else {
          sw.classList.remove("js-invisible");
        }
      });
    };

    const freezeAtCurrent = (node) => {
      if (!node) return;
      const anims = node.getAnimations ? node.getAnimations() : [];
      const tf = getComputedStyle(node).transform;
      anims.forEach((a) => {
        try {
          a.cancel();
        } catch (_) {}
      });
      if (tf && tf !== "none") node.style.transform = tf;
    };

    const cancelActive = () => {
      if (!active) return;
      try {
        active.a1?.cancel?.();
      } catch (_) {}
      try {
        active.a2?.cancel?.();
      } catch (_) {}
      active = null;
    };

    function startTransition(fromIndex, targetIndex, fromReuseClone = null, fromReuseTransform = null) {
      if (targetIndex === fromIndex) return;
      if (targetIndex < 0 || targetIndex >= slides.length) return;

      // 重新检测是否为移动端，确保响应式行为正确
      var isMobileCurrent = window.matchMedia("(max-width: 999px)").matches;

      // reduced motion：直接跳转，不做 clone 动画
      if (prefersReducedMotion()) {
        animating = false;
        hideStage();
        try {
          embla.scrollTo(targetIndex, true);
        } catch (_) {
          embla.scrollTo(targetIndex);
        }
        syncButtons();
        syncDots();
        revealRealSlide(targetIndex);
        setViewportHeightToSelectedRaf();
        observeSelectedCard();
        return;
      }

      animating = true;
      showStage();

      const dir = targetIndex > fromIndex ? 1 : -1;
      const st = ensureStage();
      st.innerHTML = "";

      const fromClone = fromReuseClone || slides[fromIndex].cloneNode(true);
      const toClone = slides[targetIndex].cloneNode(true);

      fromClone.classList.add("vertical-embla__clone");
      toClone.classList.add("vertical-embla__clone");

      makeCloneSafe(fromClone);
      makeCloneSafe(toClone);

      fromClone.style.zIndex = "1";
      toClone.style.zIndex = "2";

      st.appendChild(fromClone);
      st.appendChild(toClone);

      const fromTarget = fromClone;
      const toTarget = toClone;

      fromTarget.style.transform =
        fromReuseTransform || "translate3d(0,0,0) scale(1) translateZ(0px)";

      // 根据移动端/桌面端调整动画方向
      if (isMobileCurrent) {
        toTarget.style.transform = `translate3d(${dir > 0 ? "100%" : "-100%"}, 0, 0)`;
      } else {
        toTarget.style.transform = `translate3d(0, ${dir > 0 ? "100%" : "-100%"}, 0)`;
      }

      // 先让 embla 的真实位置跳过去（保持实际可访问 slide 正确）
      try {
        embla.scrollTo(targetIndex, true);
      } catch (_) {
        embla.scrollTo(targetIndex);
      }

      // 方案B：scrollTo 后马上同步高度（目标 slide 的高度）
      setViewportHeightToSelectedRaf();

      syncButtons();
      syncDots();
      requestAnimationFrame(() => {
        syncButtons();
        syncDots();
        revealRealSlide(targetIndex);
        setViewportHeightToSelectedRaf();
        observeSelectedCard();
      });

      const duration = 800;
      const easing = "cubic-bezier(.2,.8,.2,1)";

      // 前面一张的收缩动画
      const a1 = fromTarget.animate(
        [
          {
            transform:
              fromTarget.style.transform ||
              "translate3d(0,0,0) scale(1) translateZ(0px)",
          },
          {
          transform: isMobileCurrent 
            ? `translate3d(${dir > 0 ? 72 : -72}px, 0, 0) scale(0.86) translateZ(-80px)`
            : `translate3d(0, ${dir > 0 ? 72 : -72}px, 0) scale(0.86) translateZ(-80px)`,
        },
        ],
        { duration, easing, fill: "forwards" }
      );

      // 后面一张的进入动画
      const a2 = toTarget.animate(
        [
          { 
            transform: isMobileCurrent 
              ? `translate3d(${dir > 0 ? "100%" : "-100%"}, 0, 0)`
              : `translate3d(0, ${dir > 0 ? "100%" : "-100%"}, 0)` 
          },
          { transform: "translate3d(0,0,0)" },
        ],
        { duration, easing, fill: "forwards" }
      );

      active = { a1, a2, fromTarget, toTarget, toClone, targetIndex };

      Promise.allSettled([a1.finished, a2.finished]).then(() => {
        if (!active || active.targetIndex !== targetIndex) return;

        cancelActive();
        animating = false;
        hideStage();
        syncButtons();
        syncDots();
        setViewportHeightToSelectedRaf();
        observeSelectedCard();
      });
    }

    function goTo(targetIndex) {
      const cur = embla.selectedScrollSnap();
      if (targetIndex === cur) return;
      if (targetIndex < 0 || targetIndex >= slides.length) return;

      // 重新检测是否为移动端，确保响应式行为正确
      var isMobileCurrent = window.matchMedia("(max-width: 999px)").matches;

      // 移动端使用普通滑动，不使用覆盖效果
      if (isMobileCurrent) {
        console.log("移动端", targetIndex);
        try {
          embla.scrollTo(targetIndex);
        } catch (_) {
          embla.scrollTo(targetIndex);
        }
        syncButtons();
        syncDots();
        setViewportHeightToSelectedRaf();
        observeSelectedCard();
        return;
      }

      // 桌面端保持原有覆盖效果
      if (!animating) {
        startTransition(cur, targetIndex);
        return;
      }

      // 正在动画中：复用 “toClone” 作为新的 fromClone，保持丝滑
      const reuseClone = active?.toClone;
      const reuseTarget = active?.toTarget;

      if (!reuseClone || !reuseTarget) {
        cancelActive();
        animating = false;
        hideStage();
        startTransition(embla.selectedScrollSnap(), targetIndex);
        return;
      }

      freezeAtCurrent(active.fromTarget);
      freezeAtCurrent(active.toTarget);
      cancelActive();

      const st = ensureStage();
      st.innerHTML = "";
      reuseClone.style.zIndex = "1";
      st.appendChild(reuseClone);

      const tf = getComputedStyle(reuseTarget).transform;
      const reuseTransform =
        tf && tf !== "none"
          ? tf
          : "translate3d(0,0,0) scale(1) translateZ(0px)";

      const fromIdx = embla.selectedScrollSnap();
      startTransition(fromIdx, targetIndex, reuseClone, reuseTransform);
    }

    // 初始化指示器状态
    syncDots();
    
    // 注册指示器点击事件
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goTo(index);
      });
    });
    
    // prevBtn && prevBtn.addEventListener("click", () => {
    //   const currentIndex = embla.selectedScrollSnap();
    //   // 优化循环逻辑：使用Embla内置的scrollPrev方法确保循环流畅
    //   if (embla.canScrollPrev()) {
    //     embla.scrollPrev();
    //   } else {
    //     // 如果已经是第一个，跳转到最后一个实现循环
    //     embla.scrollTo(lastSlideIndex);
    //   }
    //   syncButtons();
    //   syncDots();
    //   setViewportHeightToSelectedRaf();
    //   observeSelectedCard();
    // });
    
    // nextBtn && nextBtn.addEventListener("click", () => {
    //   const currentIndex = embla.selectedScrollSnap();
    //   // 优化循环逻辑：使用Embla内置的scrollNext方法确保循环流畅
    //   if (embla.canScrollNext()) {
    //     embla.scrollNext();
    //   } else {
    //     // 如果已经是最后一个，跳转到第一个实现循环
    //     embla.scrollTo(0);
    //   }
    //   syncButtons();
    //   syncDots();
    //   setViewportHeightToSelectedRaf();
    //   observeSelectedCard();
    // });

    // 修改向前按钮点击事件
    prevBtn && prevBtn.addEventListener("click", () => {
      const currentIndex = embla.selectedScrollSnap();
      const lastIndex = embla.slideNodes().length - 1;
      // 计算目标索引，支持循环
      const targetIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
      goTo(targetIndex); // 调用自定义动画函数
      stopAutoScroll();
    });
    
    // 修改向后按钮点击事件
    nextBtn && nextBtn.addEventListener("click", () => {
      const currentIndex = embla.selectedScrollSnap();
      const lastIndex = embla.slideNodes().length - 1;
      // 计算目标索引，支持循环
      const targetIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
      goTo(targetIndex); // 调用自定义动画函数
      stopAutoScroll();
    });
    
    // 点击右侧区域滚动到下一张
    (() => {
      let downX = 0;
      let downY = 0;
      let downT = 0;

      const onDown = (e) => {
        if (!isMobile) return;
        if (isInteractiveTarget(e.target)) return;

        const p = e.touches?.[0] || e;
        downX = p.clientX || 0;
        downY = p.clientY || 0;
        downT = performance.now();
      };

      const onUp = (e) => {
        if (!isMobile) return;
        if (isInteractiveTarget(e.target)) return;

        const p = e.changedTouches?.[0] || e;
        const upX = p.clientX || 0;
        const upY = p.clientY || 0;

        // ignore drag/swipe
        const dx = Math.abs(upX - downX);
        const dy = Math.abs(upY - downY);
        const dt = performance.now() - downT;
        if (dx > 10 || dy > 10) return;
        if (dt > 800) return;

        const vr = viewport.getBoundingClientRect();
        const thresholdX = vr.left + vr.width * 0.72 - 6; // right peek after 72%

        if (upX >= thresholdX) {
          const currentIndex = embla.selectedScrollSnap();
          // 支持循环：如果是最后一个slide，点击会跳转到第一个slide
          const nextIndex = currentIndex < lastSlideIndex ? currentIndex + 1 : 0;
          goTo(nextIndex);
        }
      };

      viewport.addEventListener('pointerdown', onDown, { capture: true, passive: true });
      viewport.addEventListener('pointerup', onUp, { capture: true, passive: true });
      viewport.addEventListener('touchstart', onDown, { capture: true, passive: true });
      viewport.addEventListener('touchend', onUp, { capture: true, passive: true });
    })();
    
    // 检测交互元素
    const isInteractiveTarget = (t) =>
      !!t?.closest?.("a,button,input,select,textarea,summary,label,[role='button'],[data-no-embla-click]");
    
    // // 最后一个slide点击跳转功能
    // if (lastSlide) {
    //   // 为最后一个slide添加特殊样式和点击事件
    //   lastSlide.style.cursor = 'pointer';
      
    //   lastSlide.addEventListener('click', (e) => {
    //     if (isInteractiveTarget(e.target)) return;
        
    //     // 这里可以添加跳转逻辑，例如：
    //     // window.location.href = '/your-page-url';
    //     // 或者打开一个链接：
    //     // window.open('/your-page-url', '_self');
        
    //     console.log('点击了最后一个slide，可以跳转到指定页面');
    //   });
    // }

    syncButtons();

    // 当轮播图部分在窗口顶部时触发滚动检测
    const sectionElement = root.closest('.shopify-section--image-with-text-slidershow');
    let autoScrollInterval = null;
    let isAutoScrolling = false;
    
    if (sectionElement && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // // 当元素进入视口顶部时
          // if (entry.isIntersecting && entry.boundingClientRect.top >= 0) {
          //   // 开始自动滚动
          //   startAutoScroll();
          // } else {
          //   // 离开视口顶部时停止自动滚动
          //   stopAutoScroll();
          // }
        });
      }, {
        threshold: 0, // 当元素刚进入视口时触发
        rootMargin: '0px 0px -50% 0px' // 只检测顶部50%区域
      });
      
      observer.observe(sectionElement);
    }
    
    // 开始自动滚动
    function startAutoScroll() {
      if (isAutoScrolling || slides.length <= 1) return;
      
      isAutoScrolling = true;
      let currentAutoIndex = embla.selectedScrollSnap();
      
      autoScrollInterval = setInterval(() => {
        // 检查轮播图是否仍在视口顶部
        const rect = sectionElement.getBoundingClientRect();
        if (rect.top < 0 || rect.bottom > window.innerHeight * 1.5) {
          stopAutoScroll();
          return;
        }
        
        // 自动切换到下一张
        currentAutoIndex = (currentAutoIndex + 1) % slides.length;
        goTo(currentAutoIndex);
        
      }, 3000); // 每3秒切换一次
    }
    
    // 停止自动滚动
    function stopAutoScroll() {
      if (autoScrollInterval) {
        clearInterval(autoScrollInterval);
        autoScrollInterval = null;
      }
      isAutoScrolling = false;
    }
    
    // 当用户手动交互时停止自动滚动
    viewport.addEventListener('touchstart', () => stopAutoScroll(), { passive: true });
    if (prevBtn) prevBtn.addEventListener('click', () => stopAutoScroll());
    if (nextBtn) nextBtn.addEventListener('click', () => stopAutoScroll());
    
    // 添加点击事件停止自动滚动
    slides.forEach(slide => {
      slide.addEventListener('click', () => stopAutoScroll());
    });
    
    // 页面隐藏时停止自动滚动
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoScroll();
      }
    });

    // 点击控制 - ::before区域向上滚动，::after区域向下滚动
    const handleClick = (event) => {
      // 移动端不启用点击切换功能
      if (isMobile) return;
      
      const slide = event.currentTarget;
      const rect = slide.getBoundingClientRect();
      const clickY = event.clientY - rect.top;
      const slideHeight = rect.height;
      const currentIndex = embla.selectedScrollSnap();
      // 点击上半部分（::before区域）
      if (clickY < slideHeight / 2) {
        // 向上滚动，切换到上一张（支持循环）
        if (embla.canScrollPrev()) {
          embla.scrollPrev();
        } else {
          embla.scrollTo(lastSlideIndex);
        }
        syncButtons();
        syncDots();
        setViewportHeightToSelectedRaf();
        observeSelectedCard();
      }
      // 点击下半部分（::after区域）
      else {
        // 向下滚动，切换到下一张（支持循环）
        if (embla.canScrollNext()) {
          embla.scrollNext();
        } else {
          embla.scrollTo(0);
        }
        syncButtons();
        syncDots();
        setViewportHeightToSelectedRaf();
        observeSelectedCard();
      }
    };

    // const handleClick = (event) => {
    //   if (window.matchMedia("(max-width: 999px)").matches) return; // 仅 PC 端执行
      
    //   const slide = event.currentTarget;
    //   const rect = slide.getBoundingClientRect();
    //   const clickY = event.clientY - rect.top;
    //   const currentIndex = embla.selectedScrollSnap();
    //   const lastIndex = embla.slideNodes().length - 1;
    
    //   if (clickY < rect.height / 2) {
    //     // 点击上半部分 -> 上一张
    //     const targetIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
    //     goTo(targetIndex);
    //   } else {
    //     // 点击下半部分 -> 下一张
    //     const targetIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
    //     goTo(targetIndex);
    //   }
    // };

 

    
    // 为每个slide添加点击事件监听
    slides.forEach(slide => {
      slide.addEventListener('click', handleClick);
    });
    
    // 当轮播图部分在窗口顶部时触发滚动检测
    const sectionElement2 = root.closest('.shopify-section--image-with-text-slidershow');
    if (sectionElement2 && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // 当元素进入视口顶部时（threshold: 0 表示刚进入视口）
          if (entry.isIntersecting && entry.boundingClientRect.top >= 0) {
            // 元素在视口顶部，可以在这里添加自动滚动逻辑
            // 例如：自动播放或高亮显示当前轮播图
            console.log('轮播图部分进入视口顶部');
          }
        });
      }, {
        threshold: 0, // 当元素刚进入视口时触发
        rootMargin: '0px 0px -80% 0px' // 只检测顶部区域
      });
      
      observer.observe(sectionElement2);
    }

    // 选中变化：按钮 + 高度 + 观察器 + 指示器（注意：你动画里也会触发 select，所以这里仍然要轻量）
    embla.on("select", () => {
      syncButtons();
      syncDots();
      setViewportHeightToSelectedRaf();
      observeSelectedCard();
    });

    embla.on("reInit", () => {
      slides = embla.slideNodes();
      cancelActive();
      animating = false;
      hideStage();
      syncButtons();
      syncDots();
      setViewportHeightToSelectedRaf();
      observeSelectedCard();
    });

    inited.add(root);
  }

  function initAll(scope = document) {
    scope.querySelectorAll("[data-embla-vertical]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-slidershow-new"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const inited = new WeakSet();
    const mobileInited = new WeakSet();

    const prefersReducedMotion = () =>
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function rafThrottle(fn) {
      let raf = 0;
      return (...args) => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          fn(...args);
        });
      };
    }

    function makeCloneSafe(el) {
      el.setAttribute('aria-hidden', 'true');

      el.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));

      el.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach((n) => n.setAttribute('tabindex', '-1'));

      el.querySelectorAll('img[loading="lazy"]').forEach((img) => img.setAttribute('loading', 'eager'));

      el.querySelectorAll('split-words').forEach((sw) => {
        sw.classList.remove('js-invisible');
        sw.removeAttribute('reveal-on-scroll');
        sw.style.opacity = '1';
        sw.style.clipPath = 'none';
        sw.style.webkitClipPath = 'none';
      });

      el.querySelectorAll('animate-element').forEach((ae) => {
        ae.style.opacity = '1';
        ae.style.transform = 'none';
      });

      el.querySelectorAll('*').forEach((n) => {
        n.style.transition = 'none';
        n.style.animation = 'none';
      });
    }

    function init(root) {
      if (!root || inited.has(root)) return;

      const viewport = root.querySelector('.vertical-embla__viewport');
      const prevBtn = root.querySelector('.embla-btn--prev');
      const nextBtn = root.querySelector('.embla-btn--next');
      if (!viewport || typeof EmblaCarousel === 'undefined') return;

      const embla = EmblaCarousel(viewport, {
        axis: 'y',
        align: 'start',
        loop: false,
        dragFree: false,
        skipSnaps: false,
        containScroll: 'trimSnaps',
        watchDrag: false,
      });

      let slides = embla.slideNodes();

      let stage = null;
      let animating = false;
      let active = null;

      const cursor = document.querySelector('mouse-cursor');
      const canUseSlideCursor =
        Boolean(cursor) &&
        (window.matchMedia('(hover: hover)').matches || window.matchMedia('(any-hover: hover)').matches) &&
        (window.matchMedia('(pointer: fine)').matches || window.matchMedia('(any-pointer: fine)').matches);
      const cursorInteractiveSelector = 'a, button, input, select, textarea, summary, [role="button"]';
      let cursorAction = null;

      const mqMobile = window.matchMedia('(max-width: 999px)');

      let ro = null;
      const setViewportHeightToSelected = () => {
        if (!mqMobile.matches) {
          viewport.style.height = '';
          return;
        }

        const idx = embla.selectedScrollSnap();
        const slide = slides[idx];
        if (!slide) return;

        const card = slide.querySelector('.vertical-embla__card') || slide;

        const h = Math.ceil(card.scrollHeight || card.getBoundingClientRect().height || 0);
        if (h > 0) viewport.style.height = `${h}px`;
      };

      const setViewportHeightToSelectedRaf = rafThrottle(setViewportHeightToSelected);

      const observeSelectedCard = () => {
        if (!mqMobile.matches) {
          ro && ro.disconnect();
          ro = null;
          return;
        }
        const idx = embla.selectedScrollSnap();
        const slide = slides[idx];
        if (!slide) return;

        const card = slide.querySelector('.vertical-embla__card') || slide;

        ro && ro.disconnect();
        if ('ResizeObserver' in window) {
          ro = new ResizeObserver(() => setViewportHeightToSelectedRaf());
          ro.observe(card);
        }

        card.querySelectorAll('img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', () => setViewportHeightToSelectedRaf(), { once: true });
          img.addEventListener('error', () => setViewportHeightToSelectedRaf(), { once: true });
        });
      };

      const onViewportEnvChange = () => {
        setViewportHeightToSelected();
        observeSelectedCard();
        try {
          embla.reInit();
        } catch (_) {}
      };

      setViewportHeightToSelected();
      observeSelectedCard();

      window.addEventListener('resize', setViewportHeightToSelectedRaf);
      if (mqMobile.addEventListener) {
        mqMobile.addEventListener('change', onViewportEnvChange);
      } else if (mqMobile.addListener) {
        mqMobile.addListener(onViewportEnvChange);
      }

      const ensureStage = () => {
        if (stage) return stage;
        stage = document.createElement('div');
        stage.className = 'vertical-embla__stage';
        viewport.appendChild(stage);
        return stage;
      };

      const showStage = () => {
        ensureStage();
        root.classList.add('is-animating');
      };

      const hideStage = () => {
        if (stage) stage.innerHTML = '';
        root.classList.remove('is-animating');
      };

      const isCursorInteractiveTarget = (target) => {
        if (!target || !target.closest) return false;
        const interactive = target.closest(cursorInteractiveSelector);
        return Boolean(interactive && viewport.contains(interactive));
      };

      const getViewportCursorAction = (event) => {
        const rect = viewport.getBoundingClientRect();
        if (!rect.height) return null;

        return event.clientY - rect.top < rect.height / 2 ? 'prev' : 'next';
      };

      const syncSlideCursorState = () => {
        if (!canUseSlideCursor || !cursorAction) return;

        const disabled = cursorAction === 'prev' ? !embla.canScrollPrev() : !embla.canScrollNext();
        cursor.setDisabled?.(disabled);
      };

      const hideSlideCursor = () => {
        if (!canUseSlideCursor) return;
        cursorAction = null;
        cursor.hide?.();
      };

      const updateSlideCursor = (event) => {
        if (!canUseSlideCursor) return;

        if (isCursorInteractiveTarget(event.target)) {
          hideSlideCursor();
          return;
        }

        cursorAction = getViewportCursorAction(event);
        if (!cursorAction) {
          hideSlideCursor();
          return;
        }

        const disabled = cursorAction === 'prev' ? !embla.canScrollPrev() : !embla.canScrollNext();

        cursor.show?.(cursorAction === 'prev' ? 'up' : 'down', { disabled });
      };

      const handleViewportCursorClick = (event) => {
        if (!canUseSlideCursor || isCursorInteractiveTarget(event.target)) return;

        const action = getViewportCursorAction(event);
        if (action === 'prev' && embla.canScrollPrev()) {
          goTo(embla.selectedScrollSnap() - 1);
        } else if (action === 'next' && embla.canScrollNext()) {
          goTo(embla.selectedScrollSnap() + 1);
        }

        updateSlideCursor(event);
      };

      const syncButtons = () => {
        if (prevBtn) prevBtn.disabled = !embla.canScrollPrev();
        if (nextBtn) nextBtn.disabled = !embla.canScrollNext();
        syncSlideCursorState();
      };

      const revealRealSlide = (index) => {
        const real = slides[index];
        if (!real) return;
        real.querySelectorAll('split-words').forEach((sw) => {
          if (typeof sw.reveal === 'function') {
            try {
              sw.reveal();
            } catch (_) {}
          } else {
            sw.classList.remove('js-invisible');
          }
        });
      };

      const freezeAtCurrent = (node) => {
        if (!node) return;
        const anims = node.getAnimations ? node.getAnimations() : [];
        const tf = getComputedStyle(node).transform;
        anims.forEach((a) => {
          try {
            a.cancel();
          } catch (_) {}
        });
        if (tf && tf !== 'none') node.style.transform = tf;
      };

      const cancelActive = () => {
        if (!active) return;
        try {
          active.a1?.cancel?.();
        } catch (_) {}
        try {
          active.a2?.cancel?.();
        } catch (_) {}
        active = null;
      };

      function startTransition(fromIndex, targetIndex, fromReuseClone = null, fromReuseTransform = null) {
        if (targetIndex === fromIndex) return;
        if (targetIndex < 0 || targetIndex >= slides.length) return;

        if (prefersReducedMotion()) {
          animating = false;
          hideStage();
          try {
            embla.scrollTo(targetIndex, true);
          } catch (_) {
            embla.scrollTo(targetIndex);
          }
          syncButtons();
          revealRealSlide(targetIndex);
          setViewportHeightToSelectedRaf();
          observeSelectedCard();
          return;
        }

        animating = true;
        showStage();

        const dir = targetIndex > fromIndex ? 1 : -1;
        const st = ensureStage();
        st.innerHTML = '';

        const fromClone = fromReuseClone || slides[fromIndex].cloneNode(true);
        const toClone = slides[targetIndex].cloneNode(true);

        fromClone.classList.add('vertical-embla__clone');
        toClone.classList.add('vertical-embla__clone');

        makeCloneSafe(fromClone);
        makeCloneSafe(toClone);

        fromClone.style.zIndex = '1';
        toClone.style.zIndex = '2';

        st.appendChild(fromClone);
        st.appendChild(toClone);

        const fromTarget = fromClone;
        const toTarget = toClone;

        fromTarget.style.transform = fromReuseTransform || 'translate3d(0,0,0) scale(1) translateZ(0px)';

        toTarget.style.transform = `translate3d(0, ${dir > 0 ? '100%' : '-100%'}, 0)`;

        try {
          embla.scrollTo(targetIndex, true);
        } catch (_) {
          embla.scrollTo(targetIndex);
        }

        setViewportHeightToSelectedRaf();

        syncButtons();
        requestAnimationFrame(() => {
          syncButtons();
          revealRealSlide(targetIndex);
          setViewportHeightToSelectedRaf();
          observeSelectedCard();
        });

        const duration = 800;
        const easing = 'cubic-bezier(.2,.8,.2,1)';

        const a1 = fromTarget.animate(
          [
            {
              transform: fromTarget.style.transform || 'translate3d(0,0,0) scale(1) translateZ(0px)',
            },
            {
              transform: `translate3d(0, ${dir > 0 ? 72 : -72}px, 0) scale(0.86) translateZ(-80px)`,
            },
          ],
          { duration, easing, fill: 'forwards' }
        );

        const a2 = toTarget.animate(
          [{ transform: `translate3d(0, ${dir > 0 ? '100%' : '-100%'}, 0)` }, { transform: 'translate3d(0,0,0)' }],
          { duration, easing, fill: 'forwards' }
        );

        active = { a1, a2, fromTarget, toTarget, toClone, targetIndex };

        Promise.allSettled([a1.finished, a2.finished]).then(() => {
          if (!active || active.targetIndex !== targetIndex) return;

          cancelActive();
          animating = false;
          hideStage();
          syncButtons();
          setViewportHeightToSelectedRaf();
          observeSelectedCard();
        });
      }

      function goTo(targetIndex) {
        const cur = embla.selectedScrollSnap();
        if (targetIndex === cur) return;
        if (targetIndex < 0 || targetIndex >= slides.length) return;

        if (!animating) {
          startTransition(cur, targetIndex);
          return;
        }

        const reuseClone = active?.toClone;
        const reuseTarget = active?.toTarget;

        if (!reuseClone || !reuseTarget) {
          cancelActive();
          animating = false;
          hideStage();
          startTransition(embla.selectedScrollSnap(), targetIndex);
          return;
        }

        freezeAtCurrent(active.fromTarget);
        freezeAtCurrent(active.toTarget);
        cancelActive();

        const st = ensureStage();
        st.innerHTML = '';
        reuseClone.style.zIndex = '1';
        st.appendChild(reuseClone);

        const tf = getComputedStyle(reuseTarget).transform;
        const reuseTransform = tf && tf !== 'none' ? tf : 'translate3d(0,0,0) scale(1) translateZ(0px)';

        const fromIdx = embla.selectedScrollSnap();
        startTransition(fromIdx, targetIndex, reuseClone, reuseTransform);
      }

      prevBtn && prevBtn.addEventListener('click', () => goTo(embla.selectedScrollSnap() - 1));
      nextBtn && nextBtn.addEventListener('click', () => goTo(embla.selectedScrollSnap() + 1));

      if (canUseSlideCursor) {
        viewport.classList.add('vertical-embla__viewport--cursor');
        viewport.addEventListener('pointerenter', updateSlideCursor);
        viewport.addEventListener('pointermove', updateSlideCursor);
        viewport.addEventListener('pointerleave', hideSlideCursor);
        viewport.addEventListener('click', handleViewportCursorClick);
      }

      syncButtons();

      embla.on('select', () => {
        syncButtons();
        setViewportHeightToSelectedRaf();
        observeSelectedCard();
      });

      embla.on('reInit', () => {
        slides = embla.slideNodes();
        cancelActive();
        animating = false;
        hideStage();
        syncButtons();
        setViewportHeightToSelectedRaf();
        observeSelectedCard();
      });

      inited.add(root);
    }

    function initAll(scope = document) {
      scope.querySelectorAll('[data-embla-vertical]').forEach(init);
      scope.querySelectorAll(".image-with-text-mobile-embla[data-embla-init='true']").forEach(initMobile);
    }

    function initMobile(root) {
      if (!root || mobileInited.has(root)) return;

      if (typeof window.__initEmblaCarousel === 'function') {
        window.__initEmblaCarousel(root);
        mobileInited.add(root);
        return;
      }

      const viewport = root.querySelector('.embla__viewport');
      const prevBtn = root.querySelector('.embla__button--prev');
      const nextBtn = root.querySelector('.embla__button--next');
      if (!viewport || typeof EmblaCarousel === 'undefined') return;

      const embla = EmblaCarousel(viewport, {
        axis: 'x',
        align: 'start',
        loop: false,
        dragFree: false,
        skipSnaps: false,
        containScroll: 'trimSnaps',
      });

      const syncButtons = () => {
        if (prevBtn) prevBtn.disabled = !embla.canScrollPrev();
        if (nextBtn) nextBtn.disabled = !embla.canScrollNext();
      };

      const reInit = () => {
        requestAnimationFrame(() => {
          try {
            embla.reInit();
          } catch (_) {}
          syncButtons();
        });
      };

      prevBtn && prevBtn.addEventListener('click', () => embla.scrollPrev());
      nextBtn && nextBtn.addEventListener('click', () => embla.scrollNext());

      embla.on('select', syncButtons);
      embla.on('reInit', syncButtons);
      window.addEventListener('resize', reInit);

      const mqMobile = window.matchMedia('(max-width: 999px)');
      if (mqMobile.addEventListener) {
        mqMobile.addEventListener('change', reInit);
      } else if (mqMobile.addListener) {
        mqMobile.addListener(reInit);
      }

      root.__emblaApi = embla;
      root.__emblaDestroy = () => {
        window.removeEventListener('resize', reInit);
        if (mqMobile.removeEventListener) {
          mqMobile.removeEventListener('change', reInit);
        } else if (mqMobile.removeListener) {
          mqMobile.removeListener(reInit);
        }
        try {
          embla.destroy();
        } catch (_) {}
      };
      root.__emblaBound = true;

      syncButtons();
      reInit();
      mobileInited.add(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (e) => initAll(e.target));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-slidershow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const inited = new WeakSet();
    const mobileInited = new WeakSet();

    const prefersReducedMotion = () =>
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function rafThrottle(fn) {
      let raf = 0;
      return (...args) => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          fn(...args);
        });
      };
    }

    function makeCloneSafe(el) {
      el.setAttribute('aria-hidden', 'true');

      el.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));

      el.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach((n) => n.setAttribute('tabindex', '-1'));

      el.querySelectorAll('img[loading="lazy"]').forEach((img) => img.setAttribute('loading', 'eager'));

      el.querySelectorAll('split-words').forEach((sw) => {
        sw.classList.remove('js-invisible');
        sw.removeAttribute('reveal-on-scroll');
        sw.style.opacity = '1';
        sw.style.clipPath = 'none';
        sw.style.webkitClipPath = 'none';
      });

      el.querySelectorAll('animate-element').forEach((ae) => {
        ae.style.opacity = '1';
        ae.style.transform = 'none';
      });

      el.querySelectorAll('*').forEach((n) => {
        n.style.transition = 'none';
        n.style.animation = 'none';
      });
    }

    function init(root) {
      if (!root || inited.has(root)) return;

      const mqMobile = window.matchMedia('(max-width: 999px)');
      const viewport = root.querySelector('.vertical-embla__viewport');
      const dots = root.querySelectorAll('.vertical-embla__dot');
      
      let prevBtn, nextBtn;
      if (mqMobile.matches) {
        prevBtn = root.querySelector('.embla-btn--prev-mobile');
        nextBtn = root.querySelector('.embla-btn--next-mobile');
      } else {
        prevBtn = root.querySelector('.embla-btn--prev-pc');
        nextBtn = root.querySelector('.embla-btn--next-pc');
      }

      if (!viewport || typeof EmblaCarousel === 'undefined') return;

      const embla = EmblaCarousel(viewport, {
        axis: mqMobile.matches ? 'x' : 'y',
        align: 'start',
        loop: false,
        dragFree: false,
        skipSnaps: false,
        containScroll: 'trimSnaps',
        watchDrag: mqMobile.matches,
      });

      let slides = embla.slideNodes();

      let stage = null;
      let animating = false;
      let active = null;

      const cursor = document.querySelector('mouse-cursor');
      const canUseSlideCursor =
        Boolean(cursor) &&
        (window.matchMedia('(hover: hover)').matches || window.matchMedia('(any-hover: hover)').matches) &&
        (window.matchMedia('(pointer: fine)').matches || window.matchMedia('(any-pointer: fine)').matches);
      const cursorInteractiveSelector = 'a, button, input, select, textarea, summary, [role="button"]';
      let cursorAction = null;

      let ro = null;
      const setViewportHeightToSelected = () => {
        if (!mqMobile.matches) {
          viewport.style.height = '';
          return;
        }

        const idx = embla.selectedScrollSnap();
        const slide = slides[idx];
        if (!slide) return;

        const card = slide.querySelector('.vertical-embla__card') || slide;

        const h = Math.ceil(card.scrollHeight || card.getBoundingClientRect().height || 0);
        if (h > 0) viewport.style.height = `${h}px`;
      };

      const setViewportHeightToSelectedRaf = rafThrottle(setViewportHeightToSelected);

      const observeSelectedCard = () => {
        if (!mqMobile.matches) {
          ro && ro.disconnect();
          ro = null;
          return;
        }
        const idx = embla.selectedScrollSnap();
        const slide = slides[idx];
        if (!slide) return;

        const card = slide.querySelector('.vertical-embla__card') || slide;

        ro && ro.disconnect();
        if ('ResizeObserver' in window) {
          ro = new ResizeObserver(() => setViewportHeightToSelectedRaf());
          ro.observe(card);
        }

        card.querySelectorAll('img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', () => setViewportHeightToSelectedRaf(), { once: true });
          img.addEventListener('error', () => setViewportHeightToSelectedRaf(), { once: true });
        });
      };

      const onViewportEnvChange = () => {
        setViewportHeightToSelected();
        observeSelectedCard();
        try {
          embla.reInit();
        } catch (_) {}
      };

      setViewportHeightToSelected();
      observeSelectedCard();

      window.addEventListener('resize', setViewportHeightToSelectedRaf);
      if (mqMobile.addEventListener) {
        mqMobile.addEventListener('change', onViewportEnvChange);
      } else if (mqMobile.addListener) {
        mqMobile.addListener(onViewportEnvChange);
      }

      const ensureStage = () => {
        if (stage) return stage;
        stage = document.createElement('div');
        stage.className = 'vertical-embla__stage';
        viewport.appendChild(stage);
        return stage;
      };

      const showStage = () => {
        ensureStage();
        root.classList.add('is-animating');
      };

      const hideStage = () => {
        if (stage) stage.innerHTML = '';
        root.classList.remove('is-animating');
      };

      const isCursorInteractiveTarget = (target) => {
        if (!target || !target.closest) return false;
        const interactive = target.closest(cursorInteractiveSelector);
        return Boolean(interactive && viewport.contains(interactive));
      };

      const getViewportCursorAction = (event) => {
        const rect = viewport.getBoundingClientRect();
        if (!rect.height) return null;

        return event.clientY - rect.top < rect.height / 2 ? 'prev' : 'next';
      };

      const syncSlideCursorState = () => {
        if (!canUseSlideCursor || !cursorAction) return;

        const disabled = cursorAction === 'prev' ? !embla.canScrollPrev() : !embla.canScrollNext();
        cursor.setDisabled?.(disabled);
      };

      const hideSlideCursor = () => {
        if (!canUseSlideCursor) return;
        cursorAction = null;
        cursor.hide?.();
      };

      const updateSlideCursor = (event) => {
        if (!canUseSlideCursor) return;

        if (isCursorInteractiveTarget(event.target)) {
          hideSlideCursor();
          return;
        }

        cursorAction = getViewportCursorAction(event);
        if (!cursorAction) {
          hideSlideCursor();
          return;
        }

        const disabled = cursorAction === 'prev' ? !embla.canScrollPrev() : !embla.canScrollNext();

        cursor.show?.(cursorAction === 'prev' ? 'up' : 'down', { disabled });
      };

      const handleViewportCursorClick = (event) => {
        if (!canUseSlideCursor || isCursorInteractiveTarget(event.target)) return;

        const action = getViewportCursorAction(event);
        if (action === 'prev' && embla.canScrollPrev()) {
          goTo(embla.selectedScrollSnap() - 1);
        } else if (action === 'next' && embla.canScrollNext()) {
          goTo(embla.selectedScrollSnap() + 1);
        }

        updateSlideCursor(event);
      };

      const syncDots = () => {
        const selected = embla.selectedScrollSnap();
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === selected);
        });
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          goTo(index);
        });
      });

      const syncButtons = () => {
        if (prevBtn) prevBtn.disabled = !embla.canScrollPrev();
        if (nextBtn) nextBtn.disabled = !embla.canScrollNext();
        
        syncDots();
        syncSlideCursorState();
      };

      const revealRealSlide = (index) => {
        const real = slides[index];
        if (!real) return;
        real.querySelectorAll('split-words').forEach((sw) => {
          if (typeof sw.reveal === 'function') {
            try {
              sw.reveal();
            } catch (_) {}
          } else {
            sw.classList.remove('js-invisible');
          }
        });
      };

      const freezeAtCurrent = (node) => {
        if (!node) return;
        const anims = node.getAnimations ? node.getAnimations() : [];
        const tf = getComputedStyle(node).transform;
        anims.forEach((a) => {
          try {
            a.cancel();
          } catch (_) {}
        });
        if (tf && tf !== 'none') node.style.transform = tf;
      };

      const cancelActive = () => {
        if (!active) return;
        try {
          active.a1?.cancel?.();
        } catch (_) {}
        try {
          active.a2?.cancel?.();
        } catch (_) {}
        active = null;
      };

      function startTransition(fromIndex, targetIndex, fromReuseClone = null, fromReuseTransform = null) {
        if (targetIndex === fromIndex) return;
        if (targetIndex < 0 || targetIndex >= slides.length) return;

        if (prefersReducedMotion()) {
          animating = false;
          hideStage();
          try {
            embla.scrollTo(targetIndex, true);
          } catch (_) {
            embla.scrollTo(targetIndex);
          }
          syncButtons();
          revealRealSlide(targetIndex);
          setViewportHeightToSelectedRaf();
          observeSelectedCard();
          return;
        }

        if (mqMobile.matches) {
          animating = false;
          hideStage();
          // 改用 Embla 原生的平滑滚动，不再使用瞬间跳转
          embla.scrollTo(targetIndex);
          
          syncButtons();
          revealRealSlide(targetIndex);
          setViewportHeightToSelectedRaf();
          observeSelectedCard();
          return;
        }

        animating = true;
        showStage();

        const dir = targetIndex > fromIndex ? 1 : -1;
        const st = ensureStage();
        st.innerHTML = '';

        const fromClone = fromReuseClone || slides[fromIndex].cloneNode(true);
        const toClone = slides[targetIndex].cloneNode(true);

        fromClone.classList.add('vertical-embla__clone');
        toClone.classList.add('vertical-embla__clone');

        makeCloneSafe(fromClone);
        makeCloneSafe(toClone);

        fromClone.style.zIndex = '1';
        toClone.style.zIndex = '2';

        st.appendChild(fromClone);
        st.appendChild(toClone);

        const fromTarget = fromClone;
        const toTarget = toClone;

        fromTarget.style.transform = fromReuseTransform || 'translate3d(0,0,0) scale(1) translateZ(0px)';

        toTarget.style.transform = `translate3d(0, ${dir > 0 ? '100%' : '-100%'}, 0)`;

        try {
          embla.scrollTo(targetIndex, true);
        } catch (_) {
          embla.scrollTo(targetIndex);
        }

        setViewportHeightToSelectedRaf();

        syncButtons();
        requestAnimationFrame(() => {
          syncButtons();
          revealRealSlide(targetIndex);
          setViewportHeightToSelectedRaf();
          observeSelectedCard();
        });

        const duration = 800;
        const easing = 'cubic-bezier(.2,.8,.2,1)';

        const a1 = fromTarget.animate(
          [
            {
              transform: fromTarget.style.transform || 'translate3d(0,0,0) scale(1) translateZ(0px)',
            },
            {
              transform: `translate3d(0, ${dir > 0 ? 72 : -72}px, 0) scale(0.86) translateZ(-80px)`,
            },
          ],
          { duration, easing, fill: 'forwards' }
        );

        const a2 = toTarget.animate(
          [{ transform: `translate3d(0, ${dir > 0 ? '100%' : '-100%'}, 0)` }, { transform: 'translate3d(0,0,0)' }],
          { duration, easing, fill: 'forwards' }
        );

        active = { a1, a2, fromTarget, toTarget, toClone, targetIndex };

        Promise.allSettled([a1.finished, a2.finished]).then(() => {
          if (!active || active.targetIndex !== targetIndex) return;

          cancelActive();
          animating = false;
          hideStage();
          syncButtons();
          setViewportHeightToSelectedRaf();
          observeSelectedCard();
        });
      }

      function goTo(targetIndex) {
        const cur = embla.selectedScrollSnap();
        if (targetIndex === cur) return;
        if (targetIndex < 0 || targetIndex >= slides.length) return;

        if (!animating) {
          startTransition(cur, targetIndex);
          return;
        }

        const reuseClone = active?.toClone;
        const reuseTarget = active?.toTarget;

        if (!reuseClone || !reuseTarget) {
          cancelActive();
          animating = false;
          hideStage();
          startTransition(embla.selectedScrollSnap(), targetIndex);
          return;
        }

        freezeAtCurrent(active.fromTarget);
        freezeAtCurrent(active.toTarget);
        cancelActive();

        const st = ensureStage();
        st.innerHTML = '';
        reuseClone.style.zIndex = '1';
        st.appendChild(reuseClone);

        const tf = getComputedStyle(reuseTarget).transform;
        const reuseTransform = tf && tf !== 'none' ? tf : 'translate3d(0,0,0) scale(1) translateZ(0px)';

        const fromIdx = embla.selectedScrollSnap();
        startTransition(fromIdx, targetIndex, reuseClone, reuseTransform);
      }

      prevBtn && prevBtn.addEventListener('click', () => goTo(embla.selectedScrollSnap() - 1));
      nextBtn && nextBtn.addEventListener('click', () => goTo(embla.selectedScrollSnap() + 1));

      if (canUseSlideCursor) {
        viewport.classList.add('vertical-embla__viewport--cursor');
        viewport.addEventListener('pointerenter', updateSlideCursor);
        viewport.addEventListener('pointermove', updateSlideCursor);
        viewport.addEventListener('pointerleave', hideSlideCursor);
        viewport.addEventListener('click', handleViewportCursorClick);
      }

      syncButtons();

      embla.on('select', () => {
        syncButtons();
        setViewportHeightToSelectedRaf();
        observeSelectedCard();
      });

      embla.on('reInit', () => {
        slides = embla.slideNodes();
        cancelActive();
        animating = false;
        hideStage();
        syncButtons();
        setViewportHeightToSelectedRaf();
        observeSelectedCard();
      });

      inited.add(root);
    }

    function initAll(scope = document) {
      scope.querySelectorAll('[data-embla-vertical]').forEach(init);
      scope.querySelectorAll(".image-with-text-mobile-embla[data-embla-init='true']").forEach(initMobile);
    }

    function initMobile(root) {
      if (!root || mobileInited.has(root)) return;

      if (typeof window.__initEmblaCarousel === 'function') {
        window.__initEmblaCarousel(root);
        mobileInited.add(root);
        return;
      }

      const viewport = root.querySelector('.embla__viewport');
      const prevBtn = root.querySelector('.embla__button--prev');
      const nextBtn = root.querySelector('.embla__button--next');
      if (!viewport || typeof EmblaCarousel === 'undefined') return;

      const embla = EmblaCarousel(viewport, {
        axis: 'x',
        align: 'start',
        loop: false,
        dragFree: false,
        skipSnaps: false,
        containScroll: 'trimSnaps',
      });

      const syncButtons = () => {
        if (prevBtn) prevBtn.disabled = !embla.canScrollPrev();
        if (nextBtn) nextBtn.disabled = !embla.canScrollNext();
      };

      const reInit = () => {
        requestAnimationFrame(() => {
          try {
            embla.reInit();
          } catch (_) {}
          syncButtons();
        });
      };

      prevBtn && prevBtn.addEventListener('click', () => embla.scrollPrev());
      nextBtn && nextBtn.addEventListener('click', () => embla.scrollNext());

      embla.on('select', syncButtons);
      embla.on('reInit', syncButtons);
      window.addEventListener('resize', reInit);

      const mqMobile = window.matchMedia('(max-width: 999px)');
      if (mqMobile.addEventListener) {
        mqMobile.addEventListener('change', reInit);
      } else if (mqMobile.addListener) {
        mqMobile.addListener(reInit);
      }

      root.__emblaApi = embla;
      root.__emblaDestroy = () => {
        window.removeEventListener('resize', reInit);
        if (mqMobile.removeEventListener) {
          mqMobile.removeEventListener('change', reInit);
        } else if (mqMobile.removeListener) {
          mqMobile.removeListener(reInit);
        }
        try {
          embla.destroy();
        } catch (_) {}
      };
      root.__emblaBound = true;

      syncButtons();
      reInit();
      mobileInited.add(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (e) => initAll(e.target));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
